module.exports = __webpack_public_path__ + "static/img/graymore_profile_800x561.ad01fe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_profile_800x561.jpg
// module id = D+ID
// module chunks = 0